export default __webpack_public_path__ + "static/media/23_TopLeftSquares_Left.f6c74ae6.mp4";